import React from 'react';

import { Button, Count, CloseIcon } from './CompareButton.styled';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isOpen: boolean;
    count: number;
}

const CompareButton: React.FC<Props> = props => {
    const { isOpen, count, ...rest } = props;

    return (
        <Button {...rest}>
            Course compare <Count>{isOpen ? <CloseIcon /> : count}</Count>
        </Button>
    );
};

export default CompareButton;
